import {api} from '../api'

export const endpointApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchEndpoint: build.query({
      query(payload) {
        return {
          url: `/endpoint/`,
          method: 'GET',
          params: {
            status: payload?.status,
            ordering: payload?.ordering,
            ...(payload?.text?.length > 0 ? {name__icontains: payload?.text} : [])
          }
        }
      },
    }),

    createEndpoint: build.query({
      query(payload) {
        return {
          url: `/endpoint/`,
          method: 'POST',
          data: payload
        }
      },
    }),


    fetchEndpointId: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/`,
          method: 'GET',
        }
      },
    }),


    updateEndpointId: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/`,
          method: 'PUT',
          data: payload.data
        }
      },
    }),

    endpointAddEmployees: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/add_employees/`,
          method: 'POST',
          data: payload.employees
        }
      },
    }),
    endpointRemoveEmployees: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/remove_employees/`,
          method: 'POST',
          data: payload.employees
        }
      },
    }),
  }),
})
